import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";
import AllRewardsBanner from "./AllRewardsBanner";
import HistoryItem from "./HistoryItem";

const History: FC = () => {
  const {
    state: { history },
  } = useRewardCenter();
  const t = useTranslations();
  const entries = history?.entries ?? [];

  return (
    <div data-slot="history" className="flex flex-col gap-2.5">
      <AllRewardsBanner />
      {entries.length > 0 && (
        <p className="font-semibold text-muted-foreground text-xs uppercase">
          {t("reward_center.history.recent")}
        </p>
      )}
      <div className="flex flex-col gap-1.5">
        {entries.map((entry) => (
          <HistoryItem key={entry.id} id={entry.id} />
        ))}
      </div>
    </div>
  );
};

export default History;
